import { FC } from "react";
import { EnterpriseAuthImage } from "../../../assets/images";
export const EnterpriseAuthImagePanel: FC = () => {
  return (
    <div className="hidden md:block w-1/2 h-screen relative">
      <img
        src={EnterpriseAuthImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
    </div>
  );
};
